import { RiCheckboxCircleFill, RiCheckboxBlankCircleLine } from "@remixicon/react";

interface BillingCheckboxProps {
  isSelected: boolean;
  onClick?: () => void;
  className?: string;
}

export default function BillingCheckbox({
  isSelected,
  onClick,
  className = "",
}: BillingCheckboxProps) {
  return (
    <div onClick={onClick} className={`flex-shrink-0 cursor-pointer ${className}`}>
      {isSelected ? (
        <RiCheckboxCircleFill className="size-6 text-primary-600" />
      ) : (
        <RiCheckboxBlankCircleLine className="size-6 text-gray-300" />
      )}
    </div>
  );
}
